import request from ".";

export const AdministrationApi = {
  getAdministration: (administration: string) =>
    request.post(
      `AdministrationDept/getAdministrationDeptByUrl?UniqueUrl=${administration}`
    ),
};
